import {Component, Inject} from '@angular/core';
import { environment } from "@environment";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(1600)
      ])
    ])]
})
export class ContactComponent {
  lat: number = environment.headquartersLat;
  lng: number = environment.headquartersLng;
  headquartersName: string = environment.headquartersName;
  headquartersStreet: string = environment.headquartersStreet;
  headquartersPostalNumber: string = environment.headquartersPostalNumber;
  headquartersCity: string = environment.headquartersCity;
  headquartersCountry: string = environment.headquartersCountry;

  contactMail: string = environment.contactMail;

  contactManagement: string = environment.contactManagement;
  contactManagementMail: string = environment.contactManagementMail;
  contactManagementPhone: string = environment.contactManagementPhone;

  contactHelpdeskMail: string = environment.contactHelpdeskMail;

  courtRegistryLink: string = environment.courtRegistryLink;
  courtNumber: string = environment.courtNumber;
  taxNumber: string = environment.taxNumber;
  ceo: string = environment.ceo;

  bankLink: string = environment.bankLink;
  bankName: string = environment.bankName;
  bankStreet: string = environment.bankStreet;
  bankPostalNumber: string = environment.bankPostalNumber;
  bankCity: string = environment.bankCity;
  bankCountry: string = environment.bankCountry;
  bankSwiftCode: string = environment.bankSwiftCode;
  bankIbanCode: string = environment.bankIbanCode;

  currentSection = 'section1';

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }

  scrollTo(section: string) {
    // @ts-ignore
    this.document.querySelector('#' + section)
    .scrollIntoView({block: 'end', behavior: 'smooth'});
  }
}
